<template>
    <div>
        <DiscountTable
            :expire-by-duration="true"
            :promotion-code-type="PromotionCodeType.COUPON"
            :data-source="dataSource"
            :loading="loading"
            :custom-row="createClickToEditRow"
            :pagination="pagination"
            @change="handleTableChange"
            @delete="(value)=>this.$emit('delete',value)">
            <template
                v-slot:updateForm="{ selectedEntityId,onSuccess }">
                <ReferralPromotionUpdateForm
                    :id="selectedEntityId"
                    @success="onSuccess" />
            </template>
        </DiscountTable>
    </div>
</template>
<script>
import MixinTable from '@/mixins/MixinTable'
import DiscountTable from '@/components/DiscountTable.vue'
import ReferralPromotionUpdateForm from '@/components/ReferralPromotionUpdateForm.vue'
import { PromotionCodeType } from '@/utils/enum'

export default {
    components: {
        DiscountTable,
        ReferralPromotionUpdateForm,
    },
    mixins: [MixinTable],
    data () {
        return {
            PromotionCodeType,
        }
    },
}
</script>
